export const SCOPES = {
    EMPLOYER_LINK: 'employer-link',
    USER_LINK: 'user-link',
    PAY_LINK: 'pay-link'
};
//# sourceMappingURL=scopes.js.map